module.exports = __webpack_public_path__ + "img/yuxi.730ed77f.png";